const Footer = ()=> {
     return(
          <footer>
               <div className="wrapper">
                    <p>Created by Alix Wagner, Emily Read, David Lee and Ryan Fulford</p>
                    <p>Built at <a href="https://junocollege.com/">Juno College</a> with the <a href="https://www.datamuse.com/api/">Datamuse API </a></p>
               </div>
          </footer>
     )
}

export default Footer;